import * as React from 'react';
import { BookingDetailSection, SectionProps } from '../../SharedSections/BookingDetailSection';
import { getFreightBookingDetails } from './FreightBookingHelpers';
import { isNullOrUndefined } from '../../../../../../../Util/TypeGuards';
import { FreightIcon } from '../../../../Icon/IconHelpers';
import { useIntl } from 'react-intl';

export function FreightDetailsSection({ booking, canEdit, onEdit, isInvoiced }: SectionProps) {
	const intl = useIntl();
	if (!booking.bookedSummary) {
		console.error('Booked summary missing, this should not happen');
		return <></>;
	}

	const freightDetails = booking.bookedSummary.freightDetail;

	if (isNullOrUndefined(freightDetails)) {
		return null;
	}

	const lineItems = getFreightBookingDetails(freightDetails, booking.bookedSummary.freightCalculation);
	const sectionContent = (
		<div className="booking-details-section__table freight-details">
			<table>
				<tbody>
					<tr>
						{lineItems.map((x, index) => (
							<tr>
								<td
									className={`booking-details-section__table-key ${index === 2 || index === 5 ? 'padding' : ''}`}
								>
									{x[0]}
								</td>
								<td
									className={`booking-details-section__table-value ${index === 2 || index === 5 ? 'padding' : ''}`}
								>
									{x[1]}
								</td>
							</tr>
						))}
					</tr>
				</tbody>
			</table>
		</div>
	);

	return (
		<BookingDetailSection
			sectionName={intl.formatMessage({
				id: 'freight-booking-details__freight-details-section__label',
				defaultMessage: 'Freight details',
			})}
			sectionContent={sectionContent}
			sectionClassName="freight-details"
			icon={{
				overrideIcon: <FreightIcon className="booking-detail-section__icon" />,
			}}
			modificationRules={{
				canEdit: canEdit,
				editType: 'freight-details',
				onEdit: onEdit,
				isInvoiced: isInvoiced,
			}}
		/>
	);
}
